import Axios from 'axios';
import AxiosConfig from 'src/utilities/AxiosConfig';
import { DropdownOption, ProfitCenterResponse } from '../DailyReviewInterfaces';

const getProfitCentersByState = async (stateId: number) => {
    try {
        const response : any = await Axios.get(`${process.env.REACT_APP_API_URL}/api/DailyReview/GetProfitCentersByState?stateId=${stateId}`, AxiosConfig.configValue('min'));          
        const options : DropdownOption[] = [];
            response.data.response.map((item : ProfitCenterResponse) => {
                const pcOption : DropdownOption = {
                    label: item.ProfitCenterShortDesc,
                    id: item.ProfitCenterID
                };
                options.push(pcOption);
            });
        return { success: true, response: options }
    } catch (error) {
        return { success: false, resposne: error }
    }
};

export default getProfitCentersByState;